import React from 'react';

class CountryProfileSubSectionAnswer extends React.PureComponent {
  render() {
    const { content, className } = this.props;

    return (
      <p className={ className }>
        { content }
      </p>
    );
  }
}

export default CountryProfileSubSectionAnswer;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileSubSectionAnswer.js